/**
 * Common ancestor for all element used in chatbot code (would be abstract if it existed in js).
 * Allow sharing functionality between different elements.
 *
 * Allow instruction to be filtered on a callback based with the if method.
 */
class Instruction
{
	constructor()
	{
		this.condition = true;
	}
	if(condition)
	{
		this.condition = condition;

		return this;
	}
	resolve(variables)
	{
		this.condition = Instruction._resolveValue(this.condition, variables);
	}
	static _resolveValue(value, variables)
	{
		if (typeof value === 'function')
		{
			value = value(variables);
		}

		if (typeof value === 'string')
		{
			value = value.replace(/{(.*?)}/g, (_, variableName) => htmlEncode(variables[variableName]));
		}

		return value;
	}
}

export default Instruction
